import { defaultError } from 'common/mocks/ResponseError'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import useBoundState from 'store'
import { ErrorDetails } from 'store/error/types'
import { errorHandling, redirectRoute } from 'store/utils/provider'
import { StateCreator } from 'zustand'
import { TabIdEnum } from 'common/enums/TabIdEnum'
import TicketService from 'service/TicketService'

import { AfterSalesState, IAfterSalesRequest, ITicketsInfo } from './types'

export const createAfterSalesSlice: StateCreator<AfterSalesState, [], [], AfterSalesState> = (
  set,
) => ({
  tickets: {} as ITicketsInfo,
  selectedTab: TabIdEnum.MY_TICKETS,

  setSelectedTab: (tab: string | number) => {
    set({ selectedTab: tab })
  },

  getTickets: async (payload) => {
    useBoundState.setState({ isLoading: true })

    await TicketService.getTickets()
      .then((response) => {
        const { eligible, tickets } = response
        useBoundState.setState({
          eligibility: { enabled: eligible },
          tickets,
        })

        if (payload) {
          const { onTransmission, selectedTab, history } = payload as IAfterSalesRequest
          if (selectedTab) {
            set({ selectedTab })
          }
          if (onTransmission) {
            const EMPTY_AFTER_SALES =
              response.tickets.available.length === 0 &&
              response.tickets.active.length === 0 &&
              response.tickets.completed.length === 0

            onTransmission(EMPTY_AFTER_SALES)
          }

          if (history) {
            redirectRoute(payload)
          }
        }
      })
      .catch((error) => {
        const errorDetails: ErrorDetails = {
          ...defaultError,
          route: TypesRoutes.AFTER_SALES,
        }

        errorHandling(error as Error, 'AfterSalesService.getTickets', errorDetails)
      })
      .finally(() => useBoundState.setState({ isLoading: false }))
  },
})
